<!-- <section> -->
<div id="a1" style="background: white">
  <nav class="navbar navbar-expand-xl navbar-light bg-white mt-n3">
    <a class="navbar-brand egd-navbar-brand d-none d-md-block" href="javascript:void(0)"
      (click)="openBaseLink('HOMPAGE_BASE_URL', '', '_self')">
      <img src="./assets/images/logo.png" class="egd-navbar-logo" alt="eGlobalDoctors - Care for better life" />
    </a>

    <button class="openbtn d-none d-md-block d-xl-none" (click)="toggleNav()">
      <a href="javascript:void(0)">
        <img src="./assets/images/menu_icon.svg" alt="" />
      </a>
    </button>

    <div class="row d-md-none justify-content-md-between">
      <div class="col-3">
        <button class="openbtn d-block d-xl-none" (click)="toggleNav()">
          <a href="javascript:void(0)">
            <img src="./assets/images/menu_icon.png" alt="" />
          </a>
        </button>
      </div>
      <div class="col-9">
        <a class="navbar-brand egd-navbar-brand" href="javascript:void(0)"
          (click)="openBaseLink('HOMPAGE_BASE_URL', '', '_self')">
          <img src="./assets/images/logo.png" class="egd-navbar-logo" alt="eGlobalDoctors - Care for better life" />
        </a>
      </div>
    </div>

    <div class="collapse navbar-collapse">
      <div class="consult-option">
        <div class="nav-item egd-item my-auto">
          <a class="nav-link" href="javascript:void(0)" (click)="openLink('/book-appointment')" [ngClass]="{
                'active-link': isRouteActive('/book-appointment'),
                'not-active-link': !isRouteActive('/book-appointment')
              }">
            Video Consultation
          </a>
        </div>
        <div class="nav-item egd-item my-auto">
          <a class="nav-link" href="javascript:void(0)" (click)="openLink('/expert-second-medical-opinion')" [ngClass]="{
                'active-link': isRouteActive('/expert-second-medical-opinion'),
                'not-active-link': !isRouteActive(
                  '/expert-second-medical-opinion'
                )
              }">
            <span *ngIf="!this.is_uk_country;else ukcountry">Second Opinion</span>
            <ng-template #ukcountry>
              Specialist Consultation
            </ng-template>
          </a>
        </div>
        <div class="nav-item egd-item my-auto" *ngIf="!this.is_uk_country">
          <a class="nav-link" href="javascript:void(0)" (click)="openLink('/multi-speciality-consultation')" [ngClass]="{
                'active-link': isRouteActive('/multi-speciality-consultation'),
                'not-active-link': !isRouteActive(
                  '/multi-speciality-consultation'
                )
              }">
            Multi Speciality
          </a>
        </div>
      </div>
      <div class="login-btn ml-auto">
        <div class="nav-item egd-item my-auto">
          <a class="login" href="javascript:void(0)" (click)="openLink('/')">
            Login / Register
          </a>
        </div>
      </div>
    </div>

    <div id="mySidepanel" class="sidepanel">
      <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">
        <div>×</div>
      </a>
      <a href="javascript:void(0)" (click)="openBaseLink('HOMPAGE_BASE_URL', '', '_self')" class="mt-3">Home</a>
      <div class="dropdown-mb-divider"></div>
      <a href="javascript:void(0)" (click)="openLink('/book-appointment')">Video Consultation</a>
      <div class="dropdown-mb-divider"></div>
      <a href="javascript:void(0)" (click)="openLink('/expert-second-medical-opinion')"><span *ngIf="!this.is_uk_country">Second Opinion</span><span *ngIf="this.is_uk_country">Specialist Consultation</span></a>
      <div class="dropdown-mb-divider" *ngIf="!this.is_uk_country"></div>
      <a href="javascript:void(0)" (click)="openLink('/multi-speciality-consultation')" *ngIf="!this.is_uk_country">Multi Speciality</a>
      <div class="dropdown-mb-divider"></div>
      <a href="javascript:void(0)" (click)="openLink('/')">Login / Register</a>
      <div class="dropdown-mb-divider"></div>
    </div>
  </nav>
</div>
<!-- </section> -->